<template>
  <div v-if="keyActive === keyPP" class="action action-txt">
    <div class="action_wrap">
      <h2 class="book-viewer__cats__title primary-color-txt font-size-24 font-sanpro-semibold book-viewer__cats__wrap" @click="$bvModal.show(idModalChooseSlide)">
        Power Point
      </h2>
      <div class="action__detail">
        <!-- <div class="action__upload book-viewer__cats__wrap">
          <a href="javascript:;" class="btn btn-main font-size-16 border-rd-20 form-file-hide">
            <i class="icon-upload color-light"></i>
            Tải lên
            <input type="file" id="file_pptx" ref="file_pptx" accept=".pptx" @change="uploadPowerpoint()" />
          </a>
        </div> -->
        <div class="action__section">
          <label class="action__label secondary-color-txt font-size-16 font-sanpro-semi-bold book-viewer__cats__wrap">Power Point có sẵn</label>
          <SidebarFilter class="book-viewer__cats__wrap" />
          <vue-custom-scrollbar class="action__section__list action__section__list--data action__section__list--data--scroll">
            <div v-if="datas && datas.length > 0" class="book-viewer__cats__wrap display-flex-wrap">
              <div v-for="(item, index) of datas" :key="index" class="item position-rel">
                <div class="item__head aspect-ratio aspect-ratio--16-9">
                  <div class="item__head__img">
                    <img :src="`${urlCmsImg}/${item.imageUrl}`" :alt="item.title">
                  </div>
                  <a href="javascript:;" class="item__viewer"><i class="icon-eye color-light"></i></a>
                </div>
                <div class="item__body" @click="handleViewPowerpoint(item)">
                  <h4 class="item__name">
                    {{ item.title }}
                  </h4>
                </div>
              </div>
            </div>
            <p v-else class="secondary-color-txt font-size-16 book-viewer__cats__wrap text-center">Không tìm thấy dữ liệu phù hợp</p>
            <div id="datas__end" class="display-block"></div>
          </vue-custom-scrollbar>
        </div>
      </div>
    </div>
    <b-modal :id="idModalChooseSlide" class="modal-info modal-prepare__detail" size="lg" scrollable centered>
      <template v-slot:modal-header>
        <div class="modal-info__head modal-info__head--psmall display-flex-center justify-content-between full-width">
          <div class="modal-info__title">
            <h4 class="font-sanpro-bold primary-color-txt">Thêm slide</h4>
            <p class="modal-add-slide__desc font-size-18 secondary-color-txt font-sanpro-light margin-0">Chọn các slide để sử dụng</p>
          </div>
          <span @click="$bvModal.hide(idModalChooseSlide)" class="modal-info__close"><i class="icon-close"></i></span>
        </div>
      </template>
      <div class="modal-info__body primary-color-txt font-sanpro-light bg-color-light">
        <div class="modal-add-slide__list display-flex-wrap">
          <div
            v-for="(item, index) of listSlideChoose"
            :key="index"
            class="item position-rel"
            @click="handleSetBgForSlide(item)"
            :class="{'active': item === urlBgSlideChoosed}"
          >
            <div class="item__head aspect-ratio aspect-ratio--16-9">
              <div class="item__img">
                <img :src="item" alt="Slide image">
              </div>
            </div>
            <span class="item__position font-size-14 color-light primary-bg-color">{{ index + 1 }}</span>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="modal-add-slide__footer display-flex-center justify-content-end">
          <a href="javascript:;" class="font-size-16 primary-color font-weight-semi-bold" @click="$bvModal.hide(idModalChooseSlide)">Hủy</a>
          <button
            type="button"
            class="btn btn-main font-size-16 border-rd-20 display-flex-center justify-content-center"
            @click="choosedBackgroundForSlide()"
          >
            Hoàn thành
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import ItemDataAction from './ItemDataAction.vue'
import fileService from './../../_api/fileService'
import lessonService from './../../_api/lessonService'
import SidebarFilter from './SidebarFilter.vue'
import { STORE_KEY, KEY_SLIDE, MEDIA_TYPE_PP } from './../../_store/constants'
import { APP_CONFIG } from '@/utils/constants'
import mixinsDetailLesson from './../../_store/mixinsDetailLesson'

export default {
  name: 'SidebarActionPowerpoint',
  mixins: [ mixinsDetailLesson ],
  props: {
    keyActive: String
  },
  components: {
    ItemDataAction,
    SidebarFilter,
    vueCustomScrollbar
  },
  data () {
    return {
      datas: [],
      paramSearch: {},
      keyPP: KEY_SLIDE,
      elmEndItem: null,
      observer: null,
      fileChunk: [],
      totalFileChunk: 0,
      file: {},
      idModalChooseSlide: 'modal_choose_slide',
      listSlideChoose: [],
      urlCmsImg: APP_CONFIG.urlCmsImg,
      imgCdnUrl: APP_CONFIG.bookImgCdnUrl,
      urlBgSlideChoosed: ''
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['slideCurr', 'slidesMain', 'mediaPreviewData', 'paramsSearchMediaDetail', 'slideIndexVisible'])
  },
  watch: {
    keyActive (newVal) {
      newVal === KEY_SLIDE && this.acSetParamSearchMediaDetail({...this.paramsSearchMediaDetail, classId: 0, subjectId: 0, keyword: '', documentTypeId: MEDIA_TYPE_PP, pageIndex: 1})
    },

    paramsSearchMediaDetail () {
      this.keyActive === KEY_SLIDE && this.getDatas()
    },

    fileChunk(n, o) {
      if (n.length > 0) {
        let partCount = this.totalFileChunk - n.length + 1;
        let filePartName = this.file.name + ".part_" + partCount + "." + this.totalFileChunk;
        this.uploadChunk(this.fileChunk[0], filePartName);
      }
    },
    classId () {
      return parseInt(this.$route.params.classId)
    },

    subjectId () {
      return parseInt(this.$route.params.subjectId)
    }
  },
  beforeDestroy () {
    this.observer && this.observer.unobserve(this.elmEndItem);
  },
  methods: {
    ...mapActions('common', ['setLoading']),
    ...mapActions(STORE_KEY, ['acSetSlidesMain', 'acSetSlideCurr', 'acSetMediaPreview', 'acSetParamSearchMediaDetail']),

    getDatas () {
      let self = this;
      self.setLoading(true);

      lessonService.getLessonsSample(self.paramsSearchMediaDetail)
        .then(res => {
          if (res) {
            self.datas = self.paramsSearchMediaDetail.pageIndex === 1 ? [...res.list] : [...self.datas, ...res.list]
            return res.list
          }
        })
        .then(data => {
          if (data && data.length > 0 && !self.observer) {
            // SetTimeout for render list to html
            setTimeout(() => {
              self.mountedScroll()
            }, 1500)
          }
        })
        .finally(() => { self.setLoading(false)})
    },

    mountedScroll () {
      this.elmEndItem = document.getElementById('dataios__end')
      if (this.elmEndItem && !this.observe) {
        this.observer = new IntersectionObserver(this.handleScrollEnd, {threshold: 1})
        this.observer.observe(this.elmEndItem)
      }
    },

    handleViewPowerpoint (data) {
      let self = this
      self.listSlideChoose = []
      if (data.bookLessonPlanId) {
        lessonService.getLessonsSampleDetail(data.bookLessonPlanId).then(res => {
          if (res && res.lessonPlan && res.lessonPlan.totalPage) {
            for (let i = 0; i < res.lessonPlan.totalPage; i++) {
              let imageUrl = `${self.imgCdnUrl}${res.lessonPlan.fileName}-${i + 1}.jpg`
              self.listSlideChoose.push(imageUrl)
              i === res.lessonPlan.totalPage - 1 && self.$bvModal.show(self.idModalChooseSlide)
            }
          }
        })
      }
    },

    handleSetBgForSlide (url) {
      this.urlBgSlideChoosed = url
    },

    choosedBackgroundForSlide () {
      if (this.urlBgSlideChoosed) {
        this.setBgSlide(this.urlBgSlideChoosed)
        this.handleSaveCanvas()
        this.$bvModal.hide(this.idModalChooseSlide)
      }
    },

    // uploadPowerpoint () {
    //   let self = this;
    //   self.setLoading(true);
    //   this.file = this.$refs.file_pptx.files[0];
    //   if ( this.file.type == "application/vnd.openxmlformats-officedocument.presentationml.presentation" ) {
    //     let maxFileSizeMB = 10;
    //     let bufferChunkSize = maxFileSizeMB * (1024 * 1024);
    //     let fileStreamPos = 0;
    //     let endPos = bufferChunkSize;
    //     let size = this.file.size;
    //     while (fileStreamPos < size) {
    //       this.fileChunk.push(this.file.slice(fileStreamPos, endPos));
    //       fileStreamPos = endPos;
    //       endPos = fileStreamPos + bufferChunkSize;
    //     }
    //     this.totalFileChunk = this.fileChunk.length;
    //   } else {
    //     self.setLoading(false);
    //     // alert("Vui lòng chọn file powerpoint");
    //   }
    // },

    // uploadChunk(chunk, fileName) {
    //   let formData = new FormData();
    //   formData.append("file", chunk, fileName);
    //   fileService
    //     .upload(formData)
    //     .then((response) => {
    //       if (response.data.status == "success") {
    //         this.fileChunk.shift();
    //         if (
    //           this.fileChunk.length == 0 &&
    //           response.data.data !== null &&
    //           response.data.data !== ""
    //         ) {
    //           this.createFromUpload(
    //             response.data.data,
    //             this.file.name.replace(".pptx", "")
    //           );
    //         }
    //       }
    //     })
    //     .finally();
    // },

    // createFromUpload(filePath, fileName) {
    //   let self = this;
    //   let data = {
    //     filePath: filePath,
    //     fileName: fileName,
    //     classId: this.classId,
    //     subjectId: this.subjectId
    //   };
    //   lessonService.upload(data)
    //     .then((response) => {
    //       response.data.status === 'success' && self.getDatas()
    //     })
    //     .finally(() => {
    //       self.setLoading(false);
    //     });
    // },
  }
}
</script>

<style lang="scss" scoped>
</style>
